const DISMISSED_KEY = 'hbf-ios-install-dismissed';

export function isIosSafariNotInstalled(): boolean {
  const ua = navigator.userAgent;
  const isIos =
    /iphone|ipod/i.test(ua) ||
    /ipad/i.test(ua) ||
    (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
  const isNotChromiumBased = !/crios|fxios|opios/i.test(ua);
  const isNotStandalone = !window.matchMedia('(display-mode: standalone)').matches;
  return isIos && isNotChromiumBased && isNotStandalone;
}

export function getInstallPromptDismissed(): boolean {
  try {
    return sessionStorage.getItem(DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissInstallPrompt(): void {
  try {
    sessionStorage.setItem(DISMISSED_KEY, '1');
  } catch { /* private browsing may block sessionStorage — ignore */ }
}
